/* LK — barre à paliers du panier : mise à jour dynamique + cadeaux automatiques au choix.
   Config : <script id="lk-paliers-config"> (snippets/lk-cart-fs-bar.liquid, mode config_only).
   - Total compté = cart.total_price moins les lignes cadeau (property _lk_cadeau = g1|g3).
   - Palier atteint → ajoute le cadeau choisi (sinon le 1er de la collection), 1 unité.
   - Repassé sous le palier → retire le cadeau. Quantité cadeau forcée à 1.
   - « Changer » → remplace le cadeau par un autre de la collection (choix mémorisé pour la session).
   - Cadeau retiré à la main alors que le palier est atteint → choix respecté (sessionStorage).
   - Garde-fou : un cadeau qui n'est pas à 0 € après réductions est retiré (on ne facture jamais un cadeau).
   - Lignes découpées par Shopify (réduction « Achetez X, obtenez Y ») affichées en une seule ligne par le thème :
     quantité / « Retirer » sur cette ligne → mise à jour de TOUTES ses clés (data-lk-merge-keys) via /cart/update.js.
   Déclencheurs : chargement + 'cart:refresh' (intercepteur fetch de global.js). */
(function () {
  'use strict';
  if (window.__lkPaliers) return;
  window.__lkPaliers = true;

  var busy = false;
  var again = false;
  var seen = {};    // cadeau présent au dernier passage ?
  var failed = {};  // cadeau refusé (rupture / réduction absente) → ne pas réessayer en boucle
  var lastT = null; // total au dernier rendu (animation de déblocage)
  var CFG = null;

  function cfg() {
    if (CFG) return CFG;
    var js = document.getElementById('lk-paliers-config');
    if (!js) return null;
    try { CFG = JSON.parse(js.textContent); } catch (e) { CFG = null; }
    return CFG;
  }

  function money(cents) {
    var a = (cents / 100).toFixed(2);
    var f = (CFG && CFG.mf) || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return a.replace('.', ',');
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return a;
    });
  }

  function store(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  function tier(id) {
    var c = cfg();
    if (!c) return null;
    for (var i = 0; i < c.tiers.length; i++) if (c.tiers[i].id === id) return c.tiers[i];
    return null;
  }

  function chosenVariant(t) {
    var pick = parseInt(store('lk_cadeau_choix_' + t.id), 10);
    for (var i = 0; i < t.opts.length; i++) if (t.opts[i].v === pick && !failed[pick]) return pick;
    for (var j = 0; j < t.opts.length; j++) if (!failed[t.opts[j].v]) return t.opts[j].v;
    return null;
  }

  function giftLine(cart, id) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties;
      if (p && p._lk_cadeau === id) return cart.items[i];
    }
    return null;
  }

  function eligible(cart) {
    var g = 0;
    cart.items.forEach(function (it) {
      if (it.properties && it.properties._lk_cadeau) g += it.final_line_price;
    });
    return Math.max(0, cart.total_price - g);
  }

  // paliers ordonnés : [{id:'g1',s},{id:'fs',s},{id:'g3',s}]
  function steps(c) {
    var out = [];
    c.tiers.forEach(function (t) { out.push({ id: t.id, s: t.s }); });
    out.push({ id: 'fs', s: c.fs });
    return out.sort(function (a, b) { return a.s - b.s; });
  }

  function message(t, c) {
    var st = steps(c);
    var hasG1 = !!tier('g1'), hasG3 = !!tier('g3');
    for (var i = 0; i < st.length; i++) {
      if (t < st[i].s) {
        var r = '<b>' + money(st[i].s - t) + '</b>';
        if (st[i].id === 'fs') return 'Plus que ' + r + ' pour le point relais offert';
        if (st[i].id === 'g3' && hasG1) return 'Plus que ' + r + ' pour ton 2e cadeau au choix';
        return 'Plus que ' + r + ' pour ton cadeau au choix';
      }
    }
    return 'Tout est débloqué : ' + (hasG1 && hasG3 ? '2 cadeaux' : 'ton cadeau') + ' + point relais offert';
  }

  function render(cart, c) {
    var t = eligible(cart);
    var st = steps(c);
    var next = null;
    for (var i = 0; i < st.length; i++) if (t < st[i].s) { next = st[i]; break; }
    var nGifts = (giftLine(cart, 'g1') ? 1 : 0) + (giftLine(cart, 'g3') ? 1 : 0); // cadeaux réellement dans le panier
    var grew = lastT !== null && t > lastT;
    document.querySelectorAll('[data-lk-pal]').forEach(function (bar) {
      bar.setAttribute('data-lk-total', t);
      bar.classList.toggle('is-complete', !next);
      var fill = bar.querySelector('[data-lk-fill]');
      if (fill) {
        fill.style.width = Math.min(100, (t * 100) / c.max) + '%';
        if (grew) { fill.classList.remove('lk-anim'); void fill.offsetWidth; fill.classList.add('lk-anim'); } // rayures : brève animation quand la barre avance
      }
      var msg = bar.querySelector('[data-lk-msg]');
      if (msg) msg.innerHTML = message(t, c);
      var sub = bar.querySelector('[data-lk-sub]');
      if (sub) {
        sub.hidden = nGifts === 0;
        var st = sub.querySelector('[data-lk-sub-txt]');
        if (st) st.textContent = nGifts > 1 ? 'Tes 2 cadeaux sont offerts' : 'Ton cadeau est offert';
      }
      bar.querySelectorAll('[data-s]').forEach(function (n) {
        var s = parseInt(n.getAttribute('data-s'), 10);
        var won = t >= s;
        n.classList.toggle('is-won', won);
        n.classList.toggle('is-next', !!next && next.s === s);
        if (n.classList.contains('lk-pal__node') && lastT !== null && lastT < s && won) {
          n.classList.remove('lk-pop'); void n.offsetWidth; n.classList.add('lk-pop');
        }
      });
    });
    lastT = t;
    return t;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshUI() {
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) {
      if (typeof el.onCartUpdate === 'function') el.onCartUpdate();
    });
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !s || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function release() {
    // laisse passer le cart:refresh émis par nos propres appels avant de réécouter
    setTimeout(function () {
      busy = false;
      if (again) { again = false; sync(); }
    }, 400);
  }

  function sync() {
    if (busy) { again = true; return; }
    var c = cfg();
    if (!c) return;
    busy = true;
    var changed = false;

    getCart()
      .then(function (cart) {
        var t = render(cart, c);
        var chain = Promise.resolve();
        c.tiers.forEach(function (g) {
          var line = giftLine(cart, g.id);
          if (!line && seen[g.id] && t >= g.s) store('lk_cadeau_refus_' + g.id, '1');
          var refused = store('lk_cadeau_refus_' + g.id) === '1';
          var v = chosenVariant(g);
          if (!line && t >= g.s && v && !refused) {
            chain = chain.then(function () {
              return post('/cart/add.js', { items: [{ id: v, quantity: 1, properties: { _lk_cadeau: g.id } }] })
                .then(function () { seen[g.id] = true; changed = true; })
                .catch(function () { failed[v] = true; seen[g.id] = false; });
            });
          } else if (line && t < g.s) {
            chain = chain.then(function () {
              return post('/cart/change.js', { id: line.key, quantity: 0 })
                .then(function () { seen[g.id] = false; changed = true; });
            });
          } else if (line && line.quantity > 1) {
            chain = chain.then(function () {
              return post('/cart/change.js', { id: line.key, quantity: 1 })
                .then(function () { seen[g.id] = true; changed = true; });
            });
          } else {
            seen[g.id] = !!line;
          }
        });
        return chain;
      })
      .then(getCart)
      .then(function (cart) {
        // garde-fou : un cadeau n'est jamais facturé (réduction absente, modifiée ou non cumulable)
        var chain = Promise.resolve();
        c.tiers.forEach(function (g) {
          var line = giftLine(cart, g.id);
          if (line && line.final_line_price > 0) {
            failed[line.variant_id] = true;
            changed = true;
            chain = chain.then(function () {
              return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { seen[g.id] = false; });
            });
            if (window.console) console.warn('[lk-paliers] cadeau ' + g.id + ' non offert par les réductions → retiré');
          }
        });
        if (!changed) return;
        return chain.then(getCart).then(function (cart2) { render(cart2, c); refreshUI(); });
      })
      .catch(function () {})
      .then(release);
  }

  function pick(tierId, v, btn) {
    var c = cfg();
    if (!c) return;
    if (busy) { setTimeout(function () { pick(tierId, v, btn); }, 300); return; }
    busy = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    store('lk_cadeau_choix_' + tierId, String(v));
    try { sessionStorage.removeItem('lk_cadeau_refus_' + tierId); } catch (e) {}
    getCart()
      .then(function (cart) {
        var line = giftLine(cart, tierId);
        var rm = line ? post('/cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve();
        return rm.then(function () {
          return post('/cart/add.js', { items: [{ id: v, quantity: 1, properties: { _lk_cadeau: tierId } }] });
        });
      })
      .then(function () { seen[tierId] = true; })
      .catch(function () { failed[v] = true; })
      .then(function () { refreshUI(); })
      .then(release, release);
  }

  function togglePanel(tg, forceOpen) {
    var panel = document.getElementById(tg.getAttribute('aria-controls'));
    if (!panel) return;
    var open = forceOpen ? true : panel.hidden;
    panel.hidden = !open;
    tg.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      try { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) { panel.scrollIntoView(); }
    }
  }

  document.addEventListener('click', function (e) {
    var tg = e.target.closest && e.target.closest('[data-lk-cadeau-toggle]');
    if (tg) {
      e.preventDefault();
      togglePanel(tg);
      return;
    }
    var voir = e.target.closest && e.target.closest('[data-lk-cadeau-voir]');
    if (voir) {
      e.preventDefault();
      var root = voir.closest('#CartDrawer') || document.getElementById('main-cart-items') || document;
      var first = root.querySelector('[data-lk-cadeau-toggle]');
      if (first) togglePanel(first, true);
      return;
    }
    var pk = e.target.closest && e.target.closest('[data-lk-cadeau-pick]');
    if (pk) {
      e.preventDefault();
      pick(pk.getAttribute('data-tier'), parseInt(pk.getAttribute('data-v'), 10), pk);
    }
  });

  // ----- lignes regroupées (découpage Shopify) : la quantité affichée = total de toutes les clés -----
  function mergedUpdate(keys, qty) {
    var up = {};
    keys.forEach(function (k, i) { if (k) up[k] = i === 0 ? qty : 0; });
    return post('/cart/update.js', { updates: up }).then(refreshUI).catch(refreshUI);
  }
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('input[data-lk-merge-keys]')) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    mergedUpdate(inp.getAttribute('data-lk-merge-keys').split(','), Math.max(0, parseInt(inp.value, 10) || 0));
  }, true);
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-remove-button[data-lk-merge-keys]');
    if (!rm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    mergedUpdate(rm.getAttribute('data-lk-merge-keys').split(','), 0);
  }, true);

  document.addEventListener('cart:refresh', function () { setTimeout(sync, 60); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
